"use strict";

import angular from "angular";

export class ScenarioReplicateValuesController {
    value = 0;
    form = {};
    constructor($mdDialog, locals) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.value = this.locals.value || 0;
    }

    onSubmit() {
        this.$mdDialog.hide(this.value);
    }
}

angular.module("nucont.shared").controller("ScenarioReplicateValuesController", [
        "$mdDialog",
        "locals",
        ScenarioReplicateValuesController
    ]);
